package diana.soleil.design.iraniancanadienbazzar.feature.gems

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextOverflow
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSearchBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.LoadingState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.Recipe
import diana.soleil.design.iraniancanadienbazzar.core.model.RecipeCategory
import diana.soleil.design.iraniancanadienbazzar.core.model.RecipeDifficulty
import diana.soleil.design.iraniancanadienbazzar.core.model.RecipeRegion
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.core.model.localizeDigits
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_any_option
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_back_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_diff_easy
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_diff_hard
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_diff_medium
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_error
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_category
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_difficulty
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_sort
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_filter_time
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_minutes
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_appetizer
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_bread
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_drink
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_preserve
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_rice
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_stew
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_rcat_sweet
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipe_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipes_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipes_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipes_search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_recipes_title
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_all
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_ardabil
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_gilan
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_hormozgan
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_isfahan
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_kerman
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_kermanshah
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_khuzestan
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_kurdistan
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_mashhad
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_mazandaran
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_other
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_qazvin
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_shiraz
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_tabriz
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_tehran
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_region_yazd
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_sort_liked
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_sort_newest
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_sort_quickest
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_time_30
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_time_60
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_time_90
import diana.soleil.design.iraniancanadienbazzar.feature.gems.resources.gems_time_any
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

/** Stateful entry for the recipe browser (`/gems/recipes`). */
@Composable
fun RecipesRoute(
    onBack: () -> Unit,
    onOpenRecipe: (recipeId: String) -> Unit,
    modifier: Modifier = Modifier,
    viewModel: RecipesViewModel = koinViewModel(),
) {
    val state by viewModel.state.collectAsStateWithLifecycle()
    RecipesScreen(
        state = state,
        onBack = onBack,
        onOpenRecipe = onOpenRecipe,
        onQueryChange = viewModel::onQueryChange,
        onFiltersChange = viewModel::onFiltersChange,
        modifier = modifier,
    )
}

/**
 * Recipes & Sweets browser — Stitch ID pending (generation timed out 2026-07-19); built from
 * `docs/HIDDEN_GEMS_PLAN.md` §5–6: search, the hero region chip rail ("journey across Iran"),
 * secondary filter pills (category/difficulty/max time/sort), and a 2-col photo-forward grid.
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun RecipesScreen(
    state: RecipesUiState,
    onBack: () -> Unit,
    onOpenRecipe: (recipeId: String) -> Unit,
    onQueryChange: (String) -> Unit,
    onFiltersChange: (RecipeFilters) -> Unit,
    modifier: Modifier = Modifier,
) {
    var openSheet by remember { mutableStateOf<RecipeFilterSheet?>(null) }
    Column(
        modifier = modifier
            .fillMaxSize()
            .background(AppTheme.colors.background)
            .statusBarsPadding().navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        // ── Top bar.
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppIconButton(
                iconName = "arrow_back",
                contentDescription = stringResource(Res.string.gems_back_a11y),
                onClick = onBack,
                tint = AppTheme.colors.onSurface,
            )
            Text(
                text = stringResource(Res.string.gems_recipes_title),
                style = AppTheme.typography.headlineLg,
                color = AppTheme.colors.onSurface,
            )
        }
        AppSearchBar(
            value = state.query,
            onValueChange = onQueryChange,
            placeholder = stringResource(Res.string.gems_recipes_search_placeholder),
            leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
            modifier = Modifier
                .widthIn(max = AppTheme.sizes.contentMaxWidthCompact)
                .padding(horizontal = AppTheme.spacing.lg),
        )
        // ── Region chip rail — the hero filter (only regions with published recipes).
        LazyRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            contentPadding = PaddingValues(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
        ) {
            item("all") {
                AppChip(
                    label = stringResource(Res.string.gems_region_all),
                    selected = state.filters.region == null,
                    onClick = { onFiltersChange(state.filters.copy(region = null)) },
                )
            }
            items(state.availableRegions, key = { it.name }) { region ->
                AppChip(
                    label = region.label(),
                    selected = state.filters.region == region,
                    onClick = {
                        onFiltersChange(
                            state.filters.copy(region = if (state.filters.region == region) null else region),
                        )
                    },
                )
            }
        }
        // ── Secondary filter pills, each opening an option sheet.
        LazyRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            contentPadding = PaddingValues(horizontal = AppTheme.spacing.lg),
        ) {
            item("category") {
                AppChip(
                    label = state.filters.category?.label() ?: stringResource(Res.string.gems_filter_category),
                    selected = state.filters.category != null,
                    leadingIcon = "category",
                    onClick = { openSheet = RecipeFilterSheet.Category },
                )
            }
            item("difficulty") {
                AppChip(
                    label = state.filters.difficulty?.label() ?: stringResource(Res.string.gems_filter_difficulty),
                    selected = state.filters.difficulty != null,
                    leadingIcon = "speed",
                    onClick = { openSheet = RecipeFilterSheet.Difficulty },
                )
            }
            item("time") {
                AppChip(
                    label = state.filters.maxTotalMinutes?.let { maxTimeLabel(it) }
                        ?: stringResource(Res.string.gems_filter_time),
                    selected = state.filters.maxTotalMinutes != null,
                    leadingIcon = "schedule",
                    onClick = { openSheet = RecipeFilterSheet.Time },
                )
            }
            item("sort") {
                AppChip(
                    label = state.filters.sort.label(),
                    leadingIcon = "swap_vert",
                    onClick = { openSheet = RecipeFilterSheet.Sort },
                )
            }
        }
        // ── Grid.
        when {
            state.loading -> LoadingState()
            // Live snapshot streams reconnect on their own — no manual retry affordance.
            state.error -> EmptyState(title = stringResource(Res.string.gems_error))
            state.recipes.isEmpty() -> EmptyState(
                title = stringResource(Res.string.gems_recipes_empty_title),
                description = stringResource(Res.string.gems_recipes_empty_desc),
            )
            else -> Column(
                modifier = Modifier
                    .fillMaxSize()
                    .verticalScroll(rememberScrollState()),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                FlowRow(
                    modifier = Modifier
                        .widthIn(max = AppTheme.sizes.contentMaxWidth)
                        .fillMaxWidth()
                        .padding(horizontal = AppTheme.spacing.lg)
                        .padding(top = AppTheme.spacing.md, bottom = AppTheme.spacing.xl),
                    maxItemsInEachRow = 2,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    state.recipes.forEach { recipe ->
                        RecipeCard(
                            recipe = recipe,
                            onClick = { onOpenRecipe(recipe.id) },
                            modifier = Modifier.weight(1f),
                        )
                    }
                    // Odd count: invisible filler keeps the last card at half width.
                    if (state.recipes.size % 2 == 1) {
                        Box(modifier = Modifier.weight(1f))
                    }
                }
            }
        }
    }

    when (openSheet) {
        RecipeFilterSheet.Category -> OptionSheet(
            title = stringResource(Res.string.gems_filter_category),
            options = listOf<Pair<String, RecipeCategory?>>(stringResource(Res.string.gems_any_option) to null) +
                RecipeCategory.entries.map { it.label() to it },
            selected = state.filters.category,
            onSelect = { onFiltersChange(state.filters.copy(category = it)) },
            onDismiss = { openSheet = null },
        )
        RecipeFilterSheet.Difficulty -> OptionSheet(
            title = stringResource(Res.string.gems_filter_difficulty),
            options = listOf<Pair<String, RecipeDifficulty?>>(stringResource(Res.string.gems_any_option) to null) +
                RecipeDifficulty.entries.map { it.label() to it },
            selected = state.filters.difficulty,
            onSelect = { onFiltersChange(state.filters.copy(difficulty = it)) },
            onDismiss = { openSheet = null },
        )
        RecipeFilterSheet.Time -> OptionSheet(
            title = stringResource(Res.string.gems_filter_time),
            options = listOf(
                stringResource(Res.string.gems_time_any) to null,
                stringResource(Res.string.gems_time_30) to 30,
                stringResource(Res.string.gems_time_60) to 60,
                stringResource(Res.string.gems_time_90) to 90,
            ),
            selected = state.filters.maxTotalMinutes,
            onSelect = { onFiltersChange(state.filters.copy(maxTotalMinutes = it)) },
            onDismiss = { openSheet = null },
        )
        RecipeFilterSheet.Sort -> OptionSheet(
            title = stringResource(Res.string.gems_filter_sort),
            options = RecipeSort.entries.map { it.label() to it },
            selected = state.filters.sort,
            onSelect = { it?.let { sort -> onFiltersChange(state.filters.copy(sort = sort)) } },
            onDismiss = { openSheet = null },
        )
        null -> Unit
    }
}

private enum class RecipeFilterSheet { Category, Difficulty, Time, Sort }

/** One photo-forward recipe card: image/placeholder, title, region badge, meta, like count. */
@Composable
internal fun RecipeCard(
    recipe: Recipe,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    val lang = AppTheme.language
    AppCard(modifier = modifier, onClick = onClick) {
        Column {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(AppTheme.sizes.resultImageHeight),
            ) {
                BusinessCover(
                    imageUrl = recipe.imageUrl,
                    iconName = "skillet",
                    contentDescription = stringResource(Res.string.gems_recipe_image_a11y),
                )
            }
            Column(
                modifier = Modifier.padding(AppTheme.spacing.md),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
            ) {
                Text(
                    text = recipe.title.resolve(lang),
                    style = AppTheme.typography.bodyLg,
                    color = AppTheme.colors.onSurface,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis,
                )
                AccentBadge(label = recipe.region.label())
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                ) {
                    AppIcon(
                        name = "schedule",
                        size = AppTheme.sizes.iconSm,
                        tint = AppTheme.colors.onSurfaceVariant,
                    )
                    Text(
                        text = stringResource(
                            Res.string.gems_minutes,
                            lang.localizeDigits(recipe.totalMinutes.toString()),
                        ),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                    Text(
                        text = recipe.difficulty.label(),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                ) {
                    AppIcon(
                        name = "favorite",
                        size = AppTheme.sizes.iconSm,
                        tint = AppTheme.colors.error,
                        filled = true,
                    )
                    Text(
                        text = lang.formatCount(recipe.likeCount),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.onSurfaceVariant,
                    )
                }
            }
        }
    }
}

/** Generic single-choice option sheet used by the secondary filter pills. */
@Composable
private fun <T> OptionSheet(
    title: String,
    options: List<Pair<String, T?>>,
    selected: T?,
    onSelect: (T?) -> Unit,
    onDismiss: () -> Unit,
) {
    AppBottomSheet(onDismissRequest = onDismiss, title = title) {
        Column(modifier = Modifier.padding(bottom = AppTheme.spacing.lg)) {
            options.forEach { (label, value) ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable {
                            onSelect(value)
                            onDismiss()
                        }
                        .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.SpaceBetween,
                ) {
                    Text(
                        text = label,
                        style = AppTheme.typography.bodyLg,
                        color = if (value == selected) AppTheme.colors.primary else AppTheme.colors.onSurface,
                    )
                    if (value == selected) {
                        AppIcon(name = "check", tint = AppTheme.colors.primary)
                    }
                }
            }
        }
    }
}

@Composable
private fun maxTimeLabel(minutes: Int): String = when (minutes) {
    30 -> stringResource(Res.string.gems_time_30)
    60 -> stringResource(Res.string.gems_time_60)
    else -> stringResource(Res.string.gems_time_90)
}

/** Localized display label for a recipe region (app chrome, never content). */
@Composable
internal fun RecipeRegion.label(): String = stringResource(
    when (this) {
        RecipeRegion.Gilan -> Res.string.gems_region_gilan
        RecipeRegion.Mazandaran -> Res.string.gems_region_mazandaran
        RecipeRegion.Tabriz -> Res.string.gems_region_tabriz
        RecipeRegion.Ardabil -> Res.string.gems_region_ardabil
        RecipeRegion.Isfahan -> Res.string.gems_region_isfahan
        RecipeRegion.Shiraz -> Res.string.gems_region_shiraz
        RecipeRegion.Yazd -> Res.string.gems_region_yazd
        RecipeRegion.Kerman -> Res.string.gems_region_kerman
        RecipeRegion.Kermanshah -> Res.string.gems_region_kermanshah
        RecipeRegion.Kurdistan -> Res.string.gems_region_kurdistan
        RecipeRegion.Khuzestan -> Res.string.gems_region_khuzestan
        RecipeRegion.Mashhad -> Res.string.gems_region_mashhad
        RecipeRegion.Tehran -> Res.string.gems_region_tehran
        RecipeRegion.Qazvin -> Res.string.gems_region_qazvin
        RecipeRegion.Hormozgan -> Res.string.gems_region_hormozgan
        RecipeRegion.Other -> Res.string.gems_region_other
    },
)

@Composable
internal fun RecipeCategory.label(): String = stringResource(
    when (this) {
        RecipeCategory.Sweet -> Res.string.gems_rcat_sweet
        RecipeCategory.Stew -> Res.string.gems_rcat_stew
        RecipeCategory.Rice -> Res.string.gems_rcat_rice
        RecipeCategory.Bread -> Res.string.gems_rcat_bread
        RecipeCategory.Appetizer -> Res.string.gems_rcat_appetizer
        RecipeCategory.Drink -> Res.string.gems_rcat_drink
        RecipeCategory.Preserve -> Res.string.gems_rcat_preserve
        RecipeCategory.Other -> Res.string.gems_rcat_other
    },
)

@Composable
internal fun RecipeDifficulty.label(): String = stringResource(
    when (this) {
        RecipeDifficulty.Easy -> Res.string.gems_diff_easy
        RecipeDifficulty.Medium -> Res.string.gems_diff_medium
        RecipeDifficulty.Hard -> Res.string.gems_diff_hard
    },
)

@Composable
internal fun RecipeSort.label(): String = stringResource(
    when (this) {
        RecipeSort.MostLiked -> Res.string.gems_sort_liked
        RecipeSort.Newest -> Res.string.gems_sort_newest
        RecipeSort.Quickest -> Res.string.gems_sort_quickest
    },
)
